import React, { Component } from 'react';
import logoMV from '../../../../assets/logos/logo-mv.svg';

class TermoIndividualTemplate extends Component {
  render () {
    return (
      <div style={{paddingLeft: '60px', paddingRight: '60px', fontFamily: 'sans-serif'}}>
        <div style={{borderBottom: '2px solid', textAlign: 'center', fontSize: '22px', fontWeight: 600}}>
          <p>Notificação - Identificação de não conformidade</p>
        </div>
        <div style={{borderBottom: '2px solid', position: 'relative'}}>
          <div style={{display: 'inline-block', position: 'absolute', top: '40px'}}>
            <img style={{maxHeight: '90px', maxWidth: '150px'}}
              src={
                this.props.termoNConfConsolidado.dadosGeraisHospital &&
                this.props.termoNConfConsolidado.dadosGeraisHospital.logoBase64
                  ? `data:image/png;base64,${this.props.termoNConfConsolidado.dadosGeraisHospital.logoBase64}`
                  : logoMV
              }
              alt='logo'
            />
          </div>
          <div style={{textAlign: 'center', marginTop: '15px'}}>
            <p style={{fontWeight: 600}}>SERVIÇO DE PATOLOGIA</p>
            <p>{this.props.termoNConfConsolidado.dadosGeraisHospital && this.props.termoNConfConsolidado.dadosGeraisHospital.razaosoc}</p>
            <p>{this.props.termoNConfConsolidado.dadosGeraisHospital && this.props.termoNConfConsolidado.dadosGeraisHospital.enderecoCompleto}</p>
            <p style={{fontWeight: 600}}>REFERENTE AO EXAME:</p>
          </div>
        </div>
        <div>
          <table cellPadding='10' style={{ width: '100%', marginTop: '15px'}}>
            <tbody>
              <tr>
                <td colSpan='2'>
                  <span style={{ fontWeight: 600 }}>Laudo:</span>{' '}
                  {this.props.termoNConfConsolidado.laudo}
                </td>
              </tr>
              <tr>
                <td colSpan='2'>
                  <span style={{ fontWeight: 600 }}>Data pedido:</span>{' '}
                  {this.props.termoNConfConsolidado.dataPedido}
                </td>
              </tr>
              <tr>
                <td>
                  <span style={{ fontWeight: 600 }}>Aos cuidados:</span>{' '}
                  {this.props.termoNConfConsolidado.medicoSolicitante}
                </td>
                <td align='right'>
                  <span style={{ fontWeight: 600 }}>CRM/CNES:</span>{' '}
                  {this.props.termoNConfConsolidado.crm}
                </td>
              </tr>
              <tr>
                <td colSpan='2'>
                  <span style={{ fontWeight: 600, paddingBottom: '10px'}}>Dados da amostra:</span>
                  <div>
                    <div style={{ marginTop: '10px', marginBottom: '5px'}}>
                    <span>Paciente:</span>{' '}
                      {this.props.termoNConfConsolidado.paciente}
                    </div>
                    <div>
                      <span>Tipo de exame:</span>{' '}
                      {this.props.termoNConfConsolidado.tipoExame}
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan='2' style={{position: 'relative'}}>
                  <p style={{fontWeight: 600}}>
                    {this.props.termoNConfConsolidado.nConfAndTexto && this.props.termoNConfConsolidado.nConfAndTexto.nConf}
                  </p>
                  {this.props.termoNConfConsolidado.nConfAndTexto && this.props.termoNConfConsolidado.nConfAndTexto.observacao.length > 0 &&
                  (
                    <iframe
                      title='Observação não conformidade'
                      id='ObstermoNConfIframe'
                      srcDoc={" Observações: " + this.props.termoNConfConsolidado.nConfAndTexto.observacao}
                      onLoad={e => this.props.onload(e)}
                      style={{height: "100%", width: '100%', position: 'absolute', top: 20}}
                    />
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default TermoIndividualTemplate;



// WEBPACK FOOTER //
// ./src/app/common/inconformidade/modelos/termo.individual.template.js